import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "~/hooks/useAuth";
import { AddCloudProvisioner } from "~/pages/cloud provisioner/AddCloudProvisioner";
import { SIMPLCloudProvisioner } from "~/pages/cloud provisioner/CloudProvisioner";
import { AddCloudEnvironment } from "~/pages/cloud/AddCloudEnvironment";
import { SIMPLCloudEnvironment } from "~/pages/cloud/CloudEnvironment";
import { EditCloudEnvironment } from "~/pages/cloud/EditCloudEnvironment";
import { SIMPLContract } from "~/pages/contracts/SIMPLContracts";
import { OutputTemplateWorkspace } from "~/pages/contracts/OutputTemplateWorkspace";
import Login from "~/pages/login/KeycloackLoginForm";
import { Scripts } from "~/pages/scripts/Scripts";
import { AddVmTemplate } from "~/pages/vm/AddVmTemplate";
import { EditVmTemplate } from "~/pages/vm/EditVmTemplate";
import { SIMPLVmPolicies } from "~/pages/vm/submenu/policies/SimplVmPolicies";
import { SimplVmPostProvisioning } from "~/pages/vm/submenu/post-provisioning/SimplVmProvisioning";
import { SIMPLVmConfiguration } from "~/pages/vm/submenu/vm-configuration/SimplVmConfiguration";
import { SIMPLVmTemplate } from "~/pages/vm/VmTemplate";
import { AuthRoleGuard } from "./access/AuthRoleGuard";
import { ScriptType } from "~/pages/scripts/scripttype/ScriptType";
import { OutputTemplate } from "~/pages/output template/OutPutTemplate";

export const AuthRoutes: FunctionComponent = () => {
  const { isAuthenticated, loading } = useAuth();
const roles: string[] = JSON.parse(sessionStorage.getItem("roles") || "[]");
const isInfraAdmin = roles.includes('INFRA_ADMIN');
  if (loading) return <div>Loading...</div>;

  const redirectToLogin = <Navigate to="/login" replace />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/scripts" replace />} />

      {/* Protected Routes - using isAuthenticated directly */}
      <Route path="/scripts"  element={
          <AuthRoleGuard
            isAuthenticated={isAuthenticated}
            hasAccess={isInfraAdmin}
          >
            <Scripts />
          </AuthRoleGuard>
        } />
          <Route path="/script-type"  element={
          <AuthRoleGuard
            isAuthenticated={isAuthenticated}
            hasAccess={isInfraAdmin}
          >
            <ScriptType />
          </AuthRoleGuard>
        } />
           <Route path="/output-templates"  element={
          <AuthRoleGuard
            isAuthenticated={isAuthenticated}
            hasAccess={isInfraAdmin}
          >
            <OutputTemplate />
          </AuthRoleGuard>
        } />
       
      <Route path="/contracts" element={isAuthenticated ? <SIMPLContract /> : redirectToLogin} />
      <Route path="/contracts/:id/output-template" element={isAuthenticated ? <OutputTemplateWorkspace /> : redirectToLogin} />
       <Route
        path="/cloud-provisioner-template"
        element={isAuthenticated ? <SIMPLCloudProvisioner /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/cloud-provisioner-template/add"
        element={isAuthenticated ? <AddCloudProvisioner /> : <Navigate to="/login" replace />}
      />
      <Route path="/cloud-environment" element={isAuthenticated ? <SIMPLCloudEnvironment /> : redirectToLogin} />
      <Route path="/cloud-environment/add-cloud" element={isAuthenticated ? <AddCloudEnvironment /> : redirectToLogin} />
      <Route path="/cloud-environment/update" element={isAuthenticated ? <EditCloudEnvironment /> : redirectToLogin} />
      <Route path="/vm-template/configuration" element={isAuthenticated ? <SIMPLVmConfiguration /> : redirectToLogin} />
<Route
        path="/vm-template"
        element={
          <AuthRoleGuard
            isAuthenticated={isAuthenticated}
            hasAccess={isInfraAdmin}
          >
            <SIMPLVmTemplate />
          </AuthRoleGuard>
        }
      />
       <Route
        path="/vm-template/add-vm-template"
        element={isAuthenticated ? <AddVmTemplate editedItem={null} /> : <Navigate to="/login" replace />}
      />
       <Route
        path="/vm-template/edit-vm-template"
        element={isAuthenticated ? <EditVmTemplate/> : <Navigate to="/login" replace />}
      />

      <Route path="/vm-template/post-provisioning" element={isAuthenticated ? <SimplVmPostProvisioning /> : redirectToLogin} />
      <Route path="/vm-template/policies" element={isAuthenticated ? <SIMPLVmPolicies /> : redirectToLogin} />
    </Routes>
  );
};